import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-shared-table",
  templateUrl: "./shared-table.component.html",
  styleUrl: "./shared-table.component.scss",
})
export class SharedTableComponent implements OnInit {
  @Input() customTemplate?: TemplateRef<any>;
  @Output() onPageEvent = new EventEmitter<{ page: number; size: number }>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() archiveEvent = new EventEmitter<any>();
  @Input() searchResult!: any | null;
  /**
   * Explicit loading flag. Parents can bind `[loading]="isLoading"` to also
   * show the skeleton on refetches (page change, filter). When left false we
   * still show the skeleton until the first result arrives (see showSkeleton).
   */
  @Input() loading = false;
  currentPageIndex: number = 0;
  currentPageSize: number = 10;

  /**
   * Show the table skeleton when explicitly loading, or before the first
   * result has been received. A loaded-but-empty page yields a non-null
   * `searchResult` (with a body), so the empty state — not the skeleton —
   * renders in that case.
   */
  get showSkeleton(): boolean {
    return this.loading || this.searchResult == null;
  }

  /** Number of placeholder rows — mirrors the current page size, capped. */
  get skeletonRowCount(): number {
    const size = this.currentPageSize || 10;
    return Math.min(Math.max(size, 5), 10);
  }

  /** Iterable for *ngFor row placeholders. */
  get skeletonRows(): number[] {
    return Array.from({ length: this.skeletonRowCount });
  }

  constructor(
    public _MatPaginatorIntl: MatPaginatorIntl,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.currentPageIndex = this.searchResult?.body?.page || 0;
    this.setPaginatorLabels();
  }

  setPaginatorLabels() {
    this.translate.get("PAGINATOR.FIRST_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.firstPageLabel = res;
    });
    this.translate.get("PAGINATOR.ITEMS_PER_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.itemsPerPageLabel = res;
    });
    this.translate.get("PAGINATOR.LAST_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.lastPageLabel = res;
    });
    this.translate.get("PAGINATOR.NEXT_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.nextPageLabel = res;
    });
    this.translate.get("PAGINATOR.PREVIOUS_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.previousPageLabel = res;
    });
  }

  onPage(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.currentPageSize = event.pageSize;
    this.onPageEvent.emit({ page: event.pageIndex, size: event.pageSize });
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }
}
